export default {
  DEV: 'http://localhost:4000',
  STAGING: 'https://levmet-staging-back-4185530028e5.herokuapp.com',
  PRODUCTION: 'https://levmet-prod-back-c6e5a352f228.herokuapp.com'
  // eslint-disable-next-line no-undef
}[process.env.REACT_APP_ENV || 'DEV'];
